<script setup>
import { storeToRefs } from 'pinia'
import { useMessageStore } from '~/stores/messages'

//  Fetch messages
const messagesStore = useMessageStore()
const { messages: staticKeys } = storeToRefs(messagesStore)

// Fetch route
const route = useRoute()
const newsUid = computed(() => route?.params?.newsUid)
const centerRoute = computed(() => route.params?.centerUid)

// Fetch news details
const { data: currentNews, suspense: newsSuspense } = useFetchNewsDetail(newsUid.value)

// Fetch center details
const { data: centerDetails, suspense: centerSuspense } = useFetchCenterDetails(centerRoute.value)

// Prefetch data on the server side
onServerPrefetch(async () => {
    await newsSuspense() // Wait for the news data to finish fetching
    await centerSuspense() // Wait for the center details to finish fetching
})

// Track Page Load
trackPageLoad({
    title: TRACKING_CONSTANTS.TITLES.CONTENT_DETAILS,
    centerUid: centerDetails.value?.centerUid,
    centerName: centerDetails.value?.centerName,
    contentTitle: currentNews.value?.details?.title?.replace(/[*\n]/g, ''),
    contentType: TRACKING_CONSTANTS.MISC.NEWS,
})

// Seo
useSeoMeta({
    title: () => `${currentNews.value?.details?.title} | ${staticKeys.value?.menu_news} | ${centerDetails.value?.centerName}`
})
</script>

<template>
    <PageMainContainer :page-main-container-config="{ appFooter: true }">
        <ContentDetail :content="{ ...currentNews, type: 'news' }" />
    </PageMainContainer>
</template>
